import { render } from "./UserTasksEdit.vue?vue&type=template&id=2a635ea1&scoped=true"
import script from "./UserTasksEdit.vue?vue&type=script&lang=js"
export * from "./UserTasksEdit.vue?vue&type=script&lang=js"

import "./UserTasksEdit.vue?vue&type=style&index=0&id=2a635ea1&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a635ea1"]])

export default __exports__